import { EducationStatus } from '@novaheal/types';

const EDUCATION_STATUS = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  LAST: 'LAST',
  STUDENT: 'STUDENT',
  DONE: 'DONE',
  GUIDE: 'GUIDE',
  TEACH: 'TEACH',
  NURSING_ASSISTANT: 'NURSING_ASSISTANT',
  NURSING_ASSISTANT_TRAINEE: 'NURSING_ASSISTANT_TRAINEE',
  OTHER: 'OTHER',
} as const satisfies Record<EducationStatus, EducationStatus>;

export const EDUCATION_STATUS_OPTIONS = [
  {
    label: '1. Lehrdrittel (Generalistische Ausbildung)',
    value: EDUCATION_STATUS.FIRST,
  },
  {
    label: '2. Lehrdrittel (Generalistische Ausbildung)',
    value: EDUCATION_STATUS.SECOND,
  },
  {
    label: '3. Lehrdrittel (Generalistische Ausbildung)',
    value: EDUCATION_STATUS.LAST,
  },
  {
    label: 'Pflegefachassistenz (Ausbildung)',
    value: EDUCATION_STATUS.NURSING_ASSISTANT_TRAINEE,
  },
  {
    label: 'Studierende:r',
    value: EDUCATION_STATUS.STUDENT,
  },
  {
    label: 'Lehrende:r',
    value: EDUCATION_STATUS.TEACH,
  },
  {
    label: 'Praxisanleitende:r',
    value: EDUCATION_STATUS.GUIDE,
  },
  {
    label: 'Examinierte Pflegefachassistenz',
    value: EDUCATION_STATUS.NURSING_ASSISTANT,
  },
  {
    label: 'Examinierte Pflegefachperson',
    value: EDUCATION_STATUS.DONE,
  },
  {
    label: 'Andere',
    value: EDUCATION_STATUS.OTHER,
  },
];

const COLOR_OPTIONS = {
  [EDUCATION_STATUS.FIRST]: {
    bg: '#F0EDFE',
    label: '#4D3C9E',
  },
  [EDUCATION_STATUS.SECOND]: {
    bg: '#FFEFDA',
    label: '#8D5610',
  },
  [EDUCATION_STATUS.LAST]: {
    bg: '#E4F1FF',
    label: '#2B619C',
  },
  [EDUCATION_STATUS.STUDENT]: {
    bg: '#F1E4FF',
    label: '#733BAF',
  },
  [EDUCATION_STATUS.DONE]: {
    bg: '#DEF6EE',
    label: '#106448',
  },
  [EDUCATION_STATUS.GUIDE]: {
    bg: '#E4F1FF',
    label: '#2B619C',
  },
  [EDUCATION_STATUS.TEACH]: {
    bg: '#F0EDFE',
    label: '#4D3C9E',
  },
  [EDUCATION_STATUS.NURSING_ASSISTANT]: {
    bg: '#DEF6EE',
    label: '#106448',
  },
  [EDUCATION_STATUS.NURSING_ASSISTANT_TRAINEE]: {
    bg: '#FFEFDA',
    label: '#8D5610',
  },
  [EDUCATION_STATUS.OTHER]: {
    bg: '#DEF6EE',
    label: '#106448',
  },
  defaultColor: {
    bg: '#EEEFF1',
    label: '#333333',
  },
};

export type EducationStatusMeta = {
  labelValue: string;
  bgColor: string;
  labelColor: string;
};

export const getEducationStatusMeta = (value: string): EducationStatusMeta => {
  const { defaultColor } = COLOR_OPTIONS;
  if (!value || value === 'undefined' || value === 'null') {
    return {
      labelValue: 'Nicht festgelegt',
      bgColor: defaultColor.bg,
      labelColor: defaultColor.label,
    };
  }

  const option = EDUCATION_STATUS_OPTIONS.find((opt) => opt.value === value);
  const color = COLOR_OPTIONS[value as keyof typeof COLOR_OPTIONS] ?? defaultColor;

  return {
    labelValue: option?.label ?? value,
    bgColor: color.bg,
    labelColor: color.label,
  };
};
